module.exports = __webpack_public_path__ + "static/media/orange-nano-icon.af1046db.png";